import * as React from 'react'
import {inject, observer} from 'mobx-react'
// import styled from 'styled-components'
// import CustomModal from 'src/components/containers/CustomModal'
// import {FuneralHome} from 'src/resources'
import {ConfiguratorBox} from 'src/components/containers/configurator/ConfiguratorBox'
// import MoreInfo from 'src/components/atoms/input/buttons/MoreInfo'
// import {ConfiguratorText} from 'src/components/atoms/configurator'
import {StoreProps} from 'src/stores'
import {ProductRow} from 'src/components/molecules/admin/ProductRow'
// import {media} from 'src/utils.js'
// import Link from '../../atoms/input/buttons/Link'
// import ReactHtmlParser from 'react-html-parser';

type Props = StoreProps

interface State {
  fhModalOpen: boolean
  sharingModalOpen: boolean
}

@inject('adminStore')
@observer
export default class ProductList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
  }
 
  renderList = (props, uuid) => {
    return(
        <React.Fragment>
            {props.map((item, index) => {
                if(item.productType === 'OBITUARY' || item.productType === 'CARD' ) return <ProductRow key={index} item={item} offerid={uuid} />
            })}    
        </React.Fragment>
    )
  }

  render() {
    const { adminStore } = this.props
    const order = adminStore.getOrder

    return (
      <ConfiguratorBox
        title='Produkte'
        style={{ gridArea: 'products', marginBottom: '15px' }}>
        {this.renderList(order.products, order.uuid)}
      </ConfiguratorBox>
    )
  }
}

// const DetailContainer = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
//   grid-gap: 15px;
//   justify-content: space-around;
//   margin: 15px 30px;
//   padding: 0;
//   ${media.tablet` justify-content: unset; `}
// `

// const DetailBoxHeader = styled.div`
//   margin-bottom: 7.5px;
//   p {
//     margin: 0;
//     font-weight: bold;
//     font-size: 18px;
//     ${media.phone`font-size: 16px;`}
//   }
// `
// const ContactDetailsContainer = styled.div`
//   /* ${media.largePhone`display: none;`} */
// `

// const DetailLine = styled(ConfiguratorText)`
//   line-height: 1.15;
// `

// // const FuneralHomeInfo = styled.div`
// //   display: flex;
// //   align-items: baseline;
// //   flex-wrap: wrap;
// //   margin: 0 30px;
// //   margin-bottom: 15px;
// //   font-size: 16px;
// //   & > * {
// //     margin-right: 7.5px;
// //   }
// //   & > p {
// //     margin-bottom: 0;
// //     font-size: 18px;
// //     font-weight: bold;
// //     ${media.phone`font-size: 16px;`}
// //   }
// //   ${(props) => !props.show && 'display: none;'}
// // `

// // const FuneralHomeName = styled(VerticalAlignWrapper)`
// //   cursor: pointer;
// //   color: #9abbbf;
// //   & > p {
// //     font-size: 16px;
// //     margin: 0;
// //   }
// // `

// // const InlineInfoIcon = styled(MoreInfo)`
// //   position: unset;
// //   width: 23px;
// //   height: 23px;
// //   margin: 0 7.5px;
// // `



// WEBPACK FOOTER //
// ./src/components/organisms/admin/ProductList.tsx